import { Typography, Box } from '@mui/material';
import { SectionHeader } from './SectionHeader';

export default function StandardContractTerms() {
  return (
    <div>
      {' '}
      <SectionHeader>
        <Typography variant="subtitle1">Standard Contract Terms & Conditions</Typography>
      </SectionHeader>
      <Box
        sx={{
          p: 2,
          mb: 2,
          '@media print': {
            pageBreakBefore: 'avoid',
            breakBefore: 'avoid',
          },
        }}
      >
        {/* Payment Terms Subsection */}
        <Box
          sx={{
            '@media print': {
              pageBreakInside: 'avoid',
              breakInside: 'avoid',
            },
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontSize: '11px',
              mb: 1,
              fontWeight: 'bold',
              '@media print': {
                pageBreakAfter: 'avoid',
                breakAfter: 'avoid',
              },
            }}
          >
            Payment Terms:
          </Typography>
          <Typography variant="body2" sx={{ fontSize: '11px', mb: 2, pl: 2 }}>
            • Progress payments shall be made on a monthly basis proportionate to the Work
            satisfactorily performed and materials suitably stored on-site, less retainage not to
            exceed ten percent (10%), and shall be due within seven (7) days after Contractor's
            receipt of payment from Owner, but in no event later than thirty (30) days after
            Subcontractor's properly submitted payment application, consistent with AIA A401-2017
            §11.7.
            <br />• Final payment is due within thirty (30) days of Substantial Completion and
            acceptance of the Work.
            <br />• All change orders must be approved in writing prior to commencement of the
            changed Work.
            <br />• A finance charge of one and one-half percent (1.5%) per month shall accrue on
            any unpaid balance beyond agreed terms.
          </Typography>
        </Box>

        {/* Scope of Work Subsection */}
        <Box
          sx={{
            '@media print': {
              pageBreakInside: 'avoid',
              breakInside: 'avoid',
            },
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontSize: '11px',
              mb: 1,
              fontWeight: 'bold',
              '@media print': {
                pageBreakAfter: 'avoid',
                breakAfter: 'avoid',
              },
            }}
          >
            Scope of Work:
          </Typography>
          <Typography variant="body2" sx={{ fontSize: '11px', mb: 2, pl: 2 }}>
            • Work includes only items specifically described in this proposal unless otherwise
            agreed in writing.
            <br />• Any additional work or materials not specified herein will be charged as extras
            at current rates.
            <br />• Contractor is not responsible for existing conditions not apparent at time of
            proposal.
          </Typography>
        </Box>

        {/* Permits and Approvals Subsection */}
        <Box
          sx={{
            '@media print': {
              pageBreakInside: 'avoid',
              breakInside: 'avoid',
            },
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontSize: '11px',
              mb: 1,
              fontWeight: 'bold',
              '@media print': {
                pageBreakAfter: 'avoid',
                breakAfter: 'avoid',
              },
            }}
          >
            Permits and Approvals:
          </Typography>
          <Typography variant="body2" sx={{ fontSize: '11px', mb: 2, pl: 2 }}>
            • All necessary permits and approvals shall be obtained by the party responsible as
            specified in the contract.
            <br />• Work performed without proper permits is the responsibility of the client unless
            otherwise agreed.
          </Typography>
        </Box>

        {/* Warranty Subsection */}
        <Box
          sx={{
            '@media print': {
              pageBreakInside: 'avoid',
              breakInside: 'avoid',
            },
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontSize: '11px',
              mb: 1,
              fontWeight: 'bold',
              '@media print': {
                pageBreakAfter: 'avoid',
                breakAfter: 'avoid',
              },
            }}
          >
            Warranty:
          </Typography>
          <Typography variant="body2" sx={{ fontSize: '11px', mb: 2, pl: 2 }}>
            • All work is warranted for one (1) year from date of substantial completion against
            defects in workmanship.
            <br />• Material warranties are as provided by manufacturer.
            <br />• Normal wear and tear, abuse, or improper maintenance are excluded from warranty
            coverage.
          </Typography>
        </Box>

        {/* Insurance and Liability Subsection */}
        <Box
          sx={{
            '@media print': {
              pageBreakInside: 'avoid',
              breakInside: 'avoid',
            },
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontSize: '11px',
              mb: 1,
              fontWeight: 'bold',
              '@media print': {
                pageBreakAfter: 'avoid',
                breakAfter: 'avoid',
              },
            }}
          >
            Insurance and Liability:
          </Typography>
          <Typography variant="body2" sx={{ fontSize: '11px', mb: 2, pl: 2 }}>
            • Contractor maintains general liability and workers' compensation insurance as required
            by law.
            <br />• Client is responsible for securing and maintaining property insurance.
            <br />• Contractor's liability is limited to the contract amount for any single
            occurrence.
          </Typography>
        </Box>

        {/* Force Majeure Subsection */}
        <Box
          sx={{
            '@media print': {
              pageBreakInside: 'avoid',
              breakInside: 'avoid',
            },
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontSize: '11px',
              mb: 1,
              fontWeight: 'bold',
              '@media print': {
                pageBreakAfter: 'avoid',
                breakAfter: 'avoid',
              },
            }}
          >
            Force Majeure:
          </Typography>
          <Typography variant="body2" sx={{ fontSize: '11px', pl: 2 }}>
            • Neither party shall be liable for delays or failures in performance due to
            circumstances beyond their reasonable control, including but not limited to acts of God,
            government regulations, labor disputes, material shortages, or pandemic-related
            restrictions.
          </Typography>
        </Box>
      </Box>
    </div>
  );
}
